import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
const OrganizationPerformanceReport = (props) => {
  const [state, setState] = useState([]);
  const [responsemessage, setresponsemessage] = useState("");
  const fetchData = () => {
    setresponsemessage("");
    setState([]);

    let url = "api/organization-performance/report";
    Api.get(url)
      .then(function (response) {
        if (response.data.length == 0) {
          setresponsemessage("No data found");
        }
        setState(response.data);
      })
      .catch(function (error) {})
      .then(function () {
        // always executed
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: printRef, // ✅ new API for v3+
    documentTitle: "My PDF Document",
  });
  const MyComponentToPrint = React.forwardRef((props, ref) => (
    <div className="row" ref={ref}>
      <div className="col-sm-12">
        <h5 className="text-center">Ministry of Tourism and Wildlife</h5>
        <h5 className="text-center">National Tourism Service Portal</h5>
        <h5 className="text-center">Project Status Summary Report</h5>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">MDA name </th>
              <th scope="col">Status</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            {state.map((k) => {
              return (
                <tr>
                  <td>{k.mdaName}</td>
                  <td>{k.gradeName}</td>
                  <td>{k.totalRecords}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4">DATE:{Date.now()} </td>
              {/* <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.innitialCost, 0))}</td>
                                          <td style={{ textAlign: 'right' }}>{numberWithCommas(state.reduce((total, i) => total + i.presentBookValue, 0))}</td> */}
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="col-sm-2"></div>
    </div>
  ));
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Project Status Summary Report</li>
      </ol>
      <h1 class="page-header mb-3">Project Status Summary Report</h1>
      <div style={{ backgroundColor: "white" }}>
        <hr />
        {state.length > 0 ? (
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-3">
                <button
                  onClick={handlePrint}
                  style={{
                    padding: "10px 15px",
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                  }}
                >
                  Print to PDF
                </button>
              </div>
            </div>
            <div ref={printRef}>
              <MyComponentToPrint ref={printRef} />
            </div>
          </div>
        ) : null}
        <h3>{responsemessage}</h3>
      </div>
    </div>
  );
};
export default OrganizationPerformanceReport;
